import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { formatCurrency } from '@acorn-portal/shared/src/utils';

interface IPrice {
	value: number;
	description: string;
	direction?: string;
	color?: string;
}

const Price: FC<IPrice> = ({ value, description, direction = 'column', color = 'default' }) => {
	return (
		<Box sx={{ display: 'flex', flexDirection: direction }}>
			<Typography color={color} sx={{ fontSize: 30, fontWeight: 'bold', lineHeight: 1 }}>
				{formatCurrency(value || 0)}
			</Typography>
			<Typography sx={{ fontSize: 14 }}>{description}</Typography>
		</Box>
	);
};

export default Price;
